import React from 'react';
import { checkInClosesMs, checkInOpensMs, formatWindowTime } from '../../utils/gameSchedule';
import { Modal } from './gameBits';

// Why a check-in cannot happen right now, with the window for the game.
export default function CheckInNotice({ event, notice, onClose }) {
  const disabled = notice === 'disabled';
  const early = notice === 'too_early';
  return (
    <Modal label="Check in" onClose={onClose}>
      <h2>Check in</h2>
      {disabled ? (
        <>
          <p className="games-dialog-note">Check-in is disabled for this game</p>
          <p className="games-dialog-copy">This game does not have check-in enabled.</p>
        </>
      ) : (
        <>
          <p className="games-dialog-note">{early ? "Check-in isn't open yet" : 'Check-in is closed'}</p>
          <p className="games-dialog-copy">
            {early
              ? 'You can check in 15 minutes before the game starts. Come back during the window below.'
              : 'The check-in window for this game has ended.'}
          </p>
          <div className="games-window">
            <span>
              <em>Opens</em>
              <strong>{formatWindowTime(checkInOpensMs(event)) || 'TBD'}</strong>
            </span>
            <span>
              <em>Closes</em>
              <strong>{formatWindowTime(checkInClosesMs(event)) || 'TBD'}</strong>
            </span>
          </div>
        </>
      )}
      <div className="games-dialog-actions">
        <button type="button" className="games-btn is-primary" onClick={onClose}>
          Back to games
        </button>
      </div>
    </Modal>
  );
}
